(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "../StackRouter/matchPath", "../StackRouter/matchRoute", "../StackSwitch/useLocationKey", "url-parse", "deep-equal", "../constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("../StackRouter/matchPath"), require("../StackRouter/matchRoute"), require("../StackSwitch/useLocationKey"), require("url-parse"), require("deep-equal"), require("../constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.matchPath, global.matchRoute, global.useLocationKey, global.urlParse, global.deepEqual, global.constants);
    global.useCreateLinkObject = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _matchPath, _matchRoute, _useLocationKey, _urlParse, _deepEqual, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useCreateLinkObject = useCreateLinkObject;
  _urlParse = _interopRequireDefault(_urlParse);
  _deepEqual = _interopRequireDefault(_deepEqual);
  var _excluded = ["pathname", "query", "hash"],
      _excluded2 = ["pathname", "query", "hash"];

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function matchEqual(a, b) {
    var exceptExact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (exceptExact) {
      a = _objectSpread(_objectSpread({}, a), {}, {
        isExact: undefined
      });
      b = _objectSpread(_objectSpread({}, b), {}, {
        isExact: undefined
      });
    }

    return (0, _deepEqual.default)(a, b);
  }

  function useCreateLinkObject(match) {
    var _location = (0, _reactRouter.useLocation)();

    var history = (0, _reactRouter.useHistory)();

    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        routes = _useContext.routes,
        routerIndex = _useContext.routerIndex,
        locationHistory = _useContext.locationHistory;

    var getPositionOffset = locationHistory.getPositionOffset;
    var createLinkObject = (0, _react.useCallback)(function (path, state, props) {
      var location = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _location;
      var to = {};

      if (typeof path === 'function') {
        var ret = path(location);

        if (typeof ret === 'string') {
          // eslint-disable-next-line no-unused-vars
          var _url = (0, _urlParse.default)(ret),
              pathname = _url.pathname,
              query = _url.query,
              hash = _url.hash,
              parse = _objectWithoutProperties(_url, _excluded);

          to = {
            pathname: pathname,
            search: query,
            hash: hash
          };
        } else {
          to = ret;
        }
      } else if (typeof path === 'string') {
        // eslint-disable-next-line no-unused-vars
        var _url2 = (0, _urlParse.default)(path),
            _pathname = _url2.pathname,
            _query = _url2.query,
            _hash = _url2.hash,
            _parse = _objectWithoutProperties(_url2, _excluded2);

        to = {
          pathname: _pathname,
          search: _query,
          hash: _hash
        };
      } else {
        to = path;
      }

      var route = (0, _matchRoute.matchRoute)(location.pathname, routes);
      var prevMatch = route ? (0, _matchPath.matchPath)(location.pathname, route.props) : null;
      var nextMatch = route ? (0, _matchPath.matchPath)(to.pathname, route.props) : null;

      var __key = (0, _useLocationKey.getLocationKeys)(location, routerIndex);

      var originalState = _objectSpread(_objectSpread({}, to.state || {}), state || {});

      if (route && matchEqual(prevMatch, nextMatch, true) && props.reuse) {
        to.state = _objectSpread(_objectSpread({}, originalState), {}, {
          __key: __key
        });
      } else {
        to.state = _objectSpread(_objectSpread({}, originalState), {}, {
          __key: __key.splice(0, __key.length - 1)
        });
      }

      return to;
    }, [_location, routerIndex, routes]);
    var push = (0, _react.useCallback)(function (pathname) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var location = arguments.length > 3 ? arguments[3] : undefined;
      history.push(createLinkObject(pathname, state, _objectSpread({
        reuse: true
      }, props), location));
      if (props.action) history._action = props.action;
      if (props.direction) history._direction = props.direction;
      if (props.viewType) history._viewType = props.viewType;
    }, [history, createLinkObject]);
    var replace = (0, _react.useCallback)(function (pathname) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var location = arguments.length > 3 ? arguments[3] : undefined;
      history.replace(createLinkObject(pathname, state, _objectSpread({
        reuse: true
      }, props), location));
      if (props.action) history._action = props.action;
      if (props.direction) history._direction = props.direction;
      if (props.viewType) history._viewType = props.viewType;
    }, [history, createLinkObject]);
    var goFirst = (0, _react.useCallback)(function (event, replaceUrl) {
      var url = typeof event === 'string' ? event : replaceUrl;
      var offset = getPositionOffset();

      if (offset < 0) {
        history.go(getPositionOffset());
      } else if (url === history.location.pathname) {// do nothing.
      } else if (url) {
        replace(url, undefined, {
          direction: _constants.BACKWARD
        });
      }

      (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
    }, [replace, history, getPositionOffset]);
    var goBackView = (0, _react.useCallback)(function (event) {
      var targetLocation = locationHistory.getPrev(match.key);
      var offset = locationHistory.getPositionOffset(targetLocation.key);
      history.go(offset);
      (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
    }, [history, match, locationHistory]);
    var goBack = history.goBack;
    var go = history.go;
    return {
      push: push,
      replace: replace,
      goFirst: goFirst,
      goBack: goBack,
      goBackView: goBackView,
      go: go,
      _createLinkObject: createLinkObject
    };
  }
});